import React, { Component } from 'react';
import SalesforceUtils from '../../utils/SalesforceUtils';
import Literal from '../../../../../components/Literal';
import Checkbox from '../CustomIntegrationsComponents/checkbox';
import SearchUsers from '../CustomIntegrationsComponents/searchUsers';
import Button from '../../../../../components/Button';
import Scrollbars from '../../../../../components/ScrollBar';
import { Tab, TabContent } from '../../../../../components/Tab';
import { InfoAlert, ErrorAlert } from '../../../../../components/alerts';
import { ProviderActivation, OauthInProcess } from '..';
import Context from '../../../../../managers/Context';
import Loading from '../../../../../components/Loading';
import { PATH_IMAGE } from '../../../../../constants/Environment';
import stylejs from './styles';
import './style.scss';

export const SalesforceStatisticGrid = ({ data, literal, gender }) => {
    let oval =
        data.fallo === 0 ? (
            <span className="oval oval-green" />
        ) : (
            <span className="oval oval-yellow" />
        );
    let fallosStyle = data.fallo === 0 ? 'salesforce-stat-green' : 'salesforce-stat-yelow';
    let literalFallo =
        data.fallo === 0 ? (
            <Literal literal="label_no_failed_syncs_salesforce" />
        ) : (
            <div>
                <span>{data.fallo} </span>
                <Literal literal={literal} />
                <Literal literal="label_failed_syncs_salesforce" />
            </div>
        );
    return (
        <div className="salesforce-stats">
            <div className="entity">
                {oval}
                <Literal className="salesforce-entity-text" literal={literal} />
            </div>
            <div className="entity-detail">
                <div className="salesforce-stat-total-value">
                    <span>{data.total} </span>
                    <Literal literal={literal} />
                    <Literal literal={'label_total_sync_' + gender + '_salesforce'} />
                </div>
                <div className="salesforce-stat-detail-values">
                    <div>
                        <span>{data.creadas} </span>
                        <Literal literal={'label_total_creaciones_' + gender + '_salesforce'} />
                    </div>
                    <div>
                        <span>{data.modificadas} </span>
                        <Literal
                            literal={'label_total_actualizaciones_' + gender + '_salesforce'}
                        />
                    </div>
                    <div>
                        <span>{data.borradas} </span>
                        <Literal literal={'label_total_borrados_' + gender + '_salesforce'} />
                    </div>
                </div>
                <div className={fallosStyle}>{literalFallo}</div>
            </div>
        </div>
    );
};

export class SalesforceComponent extends Component {
    state = {};

    componentDidMount() {
        let { provider } = this.props;
        let syncEntities;
        try {
            syncEntities = JSON.parse(provider.data.UserConfiguration);
        } catch (e) {
            syncEntities = {
                accounts: 1,
                accounts_bi: 0,
                contacts: 0,
                contacts_bi: 0,
                opportunities: 0,
                opportunities_bi: 0,
                activities: 0,
                activities_bi: 0,
                events: 0,
                events_bi: 0,
                tasks: 0,
                tasks_bi: 0,
            };
        }
        if (provider && provider.data) {
            this.setState({
                providerId: provider.data.ProviderId,
                loadingSalesforceTabs: true,
                isActive: provider.data.IsActive,
                loading: true,
                showConfirmationDialog: false,
                showLoadingConfirmationDialog: false,
                salesforceOAuthProcess: false,
                validAuth: false,
                forceGoToAuthorize: false,
                showInputDialog: true,
                showUserConfiguration: false,
                syncEntities: syncEntities,
            });
            if (provider.data.IsActive) {
                this.getSalesforceData();
            } else {
                this.setState({ loading: false });
            }
        }
    }

    getSalesforceData = () => {
        let { provider } = this.props;
        let { forceGoToAuthorize } = this.state;

        Context.settingsManager.validateOauth(
            provider.data.ProviderId,
            () => {
                if (!provider.data.IsActive) {
                    Context.settingsManager.setActivation(
                        provider.data.ProviderId,
                        () => {
                            this.setState({
                                isActive: true,
                                validAuth: true,
                                salesforceOAuthProcess: false,
                            });
                            this.getTab1Data(provider.data.ProviderId);
                        },
                        (error) => {
                            console.log('error isactive');
                        },
                    );
                } else {
                    this.setState({ validAuth: true, salesforceOAuthProcess: false });
                    this.getTab1Data(provider.data.ProviderId);
                }
            },
            () => {
                if (forceGoToAuthorize === true) {
                    this.setState({ loading: false, salesforceOAuthProcess: false });
                } else {
                    this.setState({ loading: false });
                }
            },
            (error) => {
                this.setState({ loading: false, error: true });
            },
        );
    };

    getTab1Data = (providerId) => {
        Context.settingsManager.getCronStatus(
            providerId,
            (cronstatus) => {
                Context.settingsManager.getSalesforceSyncroLogs(
                    (data) => {
                        this.setState({
                            logData: data,
                            cronstatus: cronstatus,
                            loadingSalesforceTabs: false,
                            showUserConfiguration: false,
                            emptyLinkedUsers: false,
                            loading: false,
                        });
                        this.getTab2Data();
                    },
                    (error) => {
                        this.setState({ loadingSalesforceTabs: false, errorSalesforceTabs: true });
                    },
                );
            },
            (cronstatus) => {
                this.setState({
                    cronstatus: cronstatus,
                    loadingSalesforceTabs: false,
                    showUserConfiguration: false,
                    emptyLinkedUsers: false,
                    loading: false,
                });
            },
            (error) => {
                this.setState({ loadingSalesforceTabs: false, errorSalesforceTabs: true });
            },
        );
    };

    getTab2Data = () => {
        Context.settingsManager.syncroStats(
            (data) => {
                this.setState({
                    errorSalesforceTabs: false,
                    matchingData: data,
                    loadingSalesforceTabs: false,
                });
            },
            () => {
                this.setState({ loadingSalesforceTabs: false, errorSalesforceTabs: true });
            },
            (error) => {
                this.setState({ loadingSalesforceTabs: false, errorSalesforceTabs: true });
            },
        );
    };

    onClickAuthorize = () => {
        let { iduser, implementation } = this.props;
        this.setState({
            salesforceOAuthProcess: true,
            showConfirmationDialog: false,
            showAuthDialog: false,
            showConfiguration: false,
        });
        let child = window.open(
            SalesforceUtils.getSalesforceUrl(iduser, implementation),
            '_blank',
            'width:550,height:700,modal=yes,alwaysRaised=yes',
        );
        let timer = setInterval(() => {
            if (child.closed) {
                this.setState({ loading: true, forceGoToAuthorize: true, showInputDialog: true });
                this.getSalesforceData();
                clearInterval(timer);
            }
        }, 500);
    };

    onClickActivate = () => {
        let { implementation } = this.props;
        this.setState({ showConfirmationDialog: true });
        const data = {
            subject: `Salesforce Activation ${implementation}`,
            email: 'luis.sanfelices@forcemanager.net; oriol.parra@forcemanager.net',
            body: `La implementación ${implementation} ha intentado activar la integración con salesforce`,
        };
        Context.domainManager.sendMailSimple(
            data,
            () => {},
            () => {},
        );
    };

    onClickGoToConfig = () => {
        this.setState({ loading: true });
        Context.settingsManager.getFmAndSalesforceUsers(
            (data) => {
                let linkedUsers = this.linkedUsers(data);
                this.setState({
                    loading: false,
                    showUserConfiguration: true,
                    usersData: data,
                    linkedUsers: linkedUsers,
                });
            },
            (error) => {
                this.setState({ loading: false, error: true });
            },
        );
    };

    onClickSaveConfig = () => {
        let { syncEntities, linkedUsers, providerId } = this.state;
        if (linkedUsers && linkedUsers.length > 0) {
            this.setState({ loading: true });

            let linkedUsersObject = {};

            linkedUsersObject.service = 'salesforce';
            linkedUsersObject.entity = 'user';
            linkedUsersObject.registers = [];
            for (let i = 0; i < linkedUsers.length; i++) {
                let linkedUser = {};
                linkedUser.intId = linkedUsers[i].FMId;
                linkedUser.extId = linkedUsers[i].SalesforceId;
                linkedUsersObject.registers.push(linkedUser);
            }
            let entities = new Promise((resolve, reject) => {
                Context.settingsManager.setProviderUserConfiguration(
                    providerId,
                    syncEntities,
                    resolve,
                    reject,
                );
            });

            let users = new Promise((resolve, reject) => {
                Context.settingsManager.setSalesforceFMUserRelation(
                    linkedUsersObject,
                    resolve,
                    reject,
                );
            });

            Promise.all([entities, users]).then(
                () => {
                    Context.settingsManager.createOrUpdateJob(
                        providerId,
                        syncEntities,
                        () => {
                            this.getSalesforceData();
                        },
                        (error) => {
                            this.setState({ error: true, loading: false });
                        },
                    );
                },
                (error) => {
                    this.setState({ error: true, loading: false });
                },
            );
        } else {
            this.setState({ emptyLinkedUsers: true });
        }
    };

    onClickCancelConfig = () => {
        let { provider } = this.props;
        let syncEntitiesInit;
        try {
            syncEntitiesInit = JSON.parse(provider.data.UserConfiguration);
        } catch (e) {
            syncEntitiesInit = {
                accounts: 1,
                accounts_bi: 0,
                contacts: 0,
                contacts_bi: 0,
                opportunities: 0,
                opportunities_bi: 0,
                activities: 0,
                activities_bi: 0,
                events: 0,
                events_bi: 0,
                tasks: 0,
                tasks_bi: 0,
            };
        }
        this.setState({
            showUserConfiguration: false,
            emptyLinkedUsers: false,
            syncEntities: syncEntitiesInit,
        });
    };

    handleActivationClose = () => {
        this.setState({
            salesforceOAuthProcess: false,
            showConfirmationDialog: false,
            showAuthDialog: false,
            showDisableDialog: false,
            showInputDialog: true,
        });
    };

    handleActivation = () => {
        this.setState({
            showAuthDialog: true,
            showInputDialog: false,
            showLoadingConfirmationDialog: false,
        });
    };

    renderError = () => {
        return (
            <div className="integrations">
                <div className="description-integrations">
                    <Literal literal="error_unexpected" />
                </div>
            </div>
        );
    };

    renderLoading = () => {
        return (
            <div>
                <Loading />
            </div>
        );
    };

    renderSalesforceActivation = (provider) => {
        let { forceGoToAuthorize, isActive, validAuth } = this.state;
        let onclick =
            forceGoToAuthorize || (isActive && !validAuth)
                ? this.onClickAuthorize
                : this.onClickActivate;
        let AuthWrong = forceGoToAuthorize ? (
            <InfoAlert
                text={<Literal literal="label_oauth_interrumped_salesforce" />}
                iconDisplay={false}
            />
        ) : isActive && !validAuth ? (
            <ErrorAlert
                text={<Literal literal="label_oauth_failed_salesforce" />}
                iconDisplay={false}
            />
        ) : (
            <div />
        );
        return (
            <div>
                <ProviderActivation provider={provider} onClick={onclick} />
                {AuthWrong}
            </div>
        );
    };

    renderOauthInProcess = () => {
        return (
            <div>
                <OauthInProcess onClick={this.getSalesforceData} />
            </div>
        );
    };

    toggleCheckbox = (key) => {
        let { syncEntities } = this.state;
        if (syncEntities[key] === 1) {
            if (key === 'contacts') {
                syncEntities[key] = 0;
                syncEntities['contacts_bi'] = 0;
            } else if (key === 'opportunities') {
                syncEntities[key] = 0;
                syncEntities['opportunities_bi'] = 0;
            } else if (key === 'tasks') {
                syncEntities[key] = 0;
                syncEntities['tasks_bi'] = 0;
            } else if (key === 'events') {
                syncEntities[key] = 0;
                syncEntities['events_bi'] = 0;
            } else if (key === 'activities') {
                syncEntities[key] = 0;
                syncEntities['activities_bi'] = 0;
            } else {
                syncEntities[key] = 0;
            }
            this.setState({ syncEntities: syncEntities });
        } else {
            syncEntities[key] = 1;
            this.setState({ syncEntities: syncEntities });
        }
        //this.forceUpdate();
    };

    createCheckbox = (literal, key, isChecked, disabled, isToggle) => {
        return (
            <Checkbox
                label={<Literal literal={literal} />}
                onChange={this.toggleCheckbox}
                isChecked={isChecked}
                isDisabled={disabled}
                jsonKey={key}
                isToggle={isToggle}
            />
        );
    };

    onchangeSearch = (item, origin) => {
        if (origin === 'forcemanager') {
            this.setState({ FMUserIdToLink: item.id, FMUserToLink: item.text });
        } else {
            this.setState({ SFUserIdToLink: item.id, SFUserToLink: item.text });
        }
    };

    renderUserConfiguration = () => {
        let {
            syncEntities,
            usersData,
            linkedUsers,
            emptyLinkedUsers,
            SFUserIdToLink,
            FMUserIdToLink,
            FMUserToLink,
            SFUserToLink,
        } = this.state;

        let disableAddLinkButton = true;
        if (SFUserIdToLink && FMUserIdToLink) disableAddLinkButton = false;
        let FMUsers = usersData.usersdata[0].users;
        let SalesforceUsers = usersData.usersdata[1].users;
        let checkboxAccounts = this.createCheckbox(
            'title_accounts',
            'accounts',
            syncEntities.accounts,
            true,
            false,
        );
        let checkboxAccountsBi = this.createCheckbox(
            'label_bidireccional_salesforce',
            'accounts_bi',
            syncEntities.accounts_bi,
            false,
            true,
        );
        let checkboxContacts = this.createCheckbox(
            'title_contacts',
            'contacts',
            syncEntities.contacts,
            false,
            false,
        );
        let checkboxContactsBi = this.createCheckbox(
            'label_bidireccional_salesforce',
            'contacts_bi',
            syncEntities.contacts_bi,
            syncEntities.contacts === 0,
            true,
        );
        let checkboxOpportunities = this.createCheckbox(
            'title_opportunities',
            'opportunities',
            syncEntities.opportunities,
            false,
        );
        let checkboxOpportunitiesBi = this.createCheckbox(
            'label_bidireccional_salesforce',
            'opportunities_bi',
            syncEntities.opportunities_bi,
            syncEntities.opportunities === 0,
            true,
        );
        let checkboxActivities = this.createCheckbox(
            'title_activities',
            'activities',
            syncEntities.activities,
            false,
        );
        let checkboxActivitiesBi = this.createCheckbox(
            'label_bidireccional_salesforce',
            'activities_bi',
            syncEntities.activities_bi,
            syncEntities.activities === 0,
            true,
        );
        let checkboxEvents = this.createCheckbox(
            'title_events',
            'events',
            syncEntities.events,
            false,
        );
        let checkboxEventsBi = this.createCheckbox(
            'label_bidireccional_salesforce',
            'events_bi',
            syncEntities.events_bi,
            syncEntities.events === 0,
            true,
        );
        let checkboxTasks = this.createCheckbox('title_tasks', 'tasks', syncEntities.tasks, false);
        let checkboxTasksBi = this.createCheckbox(
            'label_bidireccional_salesforce',
            'tasks_bi',
            syncEntities.tasks_bi,
            syncEntities.tasks === 0,
            true,
        );
        let searchForcemanagerUsers = (
            <SearchUsers
                data={FMUsers}
                onChange={this.onchangeSearch}
                origin={'forcemanager'}
                searchText={FMUserToLink}
            />
        );
        let searchSalesforceUsers = (
            <SearchUsers
                data={SalesforceUsers}
                onChange={this.onchangeSearch}
                origin={'salesforce'}
                searchText={SFUserToLink}
            />
        );
        let linkedUsersContent = this.renderLinkedUsers();
        let cancelButton = (
            <div>
                <Button
                    className="btn-primary"
                    style={stylejs.btnCustomCancel}
                    text={<Literal literal="action_cancel" />}
                    onClick={this.onClickCancelConfig}
                />
            </div>
        );
        let saveButton = (
            <div>
                <Button
                    className="btn-primary"
                    style={stylejs.btnCustom}
                    text={<Literal literal="action_save" />}
                    onClick={this.onClickSaveConfig}
                />
            </div>
        );
        let addLinkedUserButton = (
            <div>
                <Button
                    className="btn-primary"
                    style={stylejs.btnCustom}
                    text={
                        <span>
                            <span>+ </span>
                            <Literal literal="action_add" />
                        </span>
                    }
                    onClick={this.addLinkedUser}
                    disabled={disableAddLinkButton}
                />
            </div>
        );
        let autoLinkUsersButton = (
            <div>
                <Button
                    className="btn-primary"
                    style={stylejs.btnCustom}
                    text={<Literal literal="action_auto_link_users_salesforce" />}
                    onClick={this.onClickAutoLinkUsers}
                />
            </div>
        );
        return (
            <div className="salesforce-inside-tab-content">
                <div className="salesforce-configuration-entities-title">
                    <Literal literal="title_configuration_salesforce" />
                </div>
                <div className="salesforce-configuration-subtitle">
                    <Literal literal="title_configuration_entities_salesforce" />
                </div>
                <div className="salesforce-configuration-link-users-desc">
                    <Literal literal="label_configuration_entities_desc_salesforce" />
                </div>
                <div className="salesforce-configuration-entities-container">
                    <div className="sync-entities-configuration">
                        <div className="checbox-entities-container">
                            {checkboxAccounts}
                            {checkboxAccountsBi}
                        </div>
                        <div className="checbox-entities-container">
                            {checkboxContacts}
                            {checkboxContactsBi}
                        </div>
                        <div className="checbox-entities-container">
                            {checkboxOpportunities}
                            {checkboxOpportunitiesBi}
                        </div>
                        <div className="checbox-entities-container">
                            {checkboxActivities}
                            {checkboxActivitiesBi}
                        </div>
                        <div className="checbox-entities-container">
                            {checkboxEvents}
                            {checkboxEventsBi}
                        </div>
                        <div className="checbox-entities-container">
                            {checkboxTasks}
                            {checkboxTasksBi}
                        </div>
                    </div>
                </div>
                <div className="salesforce-configuration-subtitle">
                    <Literal literal="title_configuration_users_salesforce" />
                </div>
                <div className="salesforce-configuration-link-users-desc">
                    <Literal literal="label_link_users_desc_salesforce" />
                </div>
                {emptyLinkedUsers ? (
                    <Literal
                        className="warning-empty-linked-users"
                        literal="label_empty_linked_users_salesforce"
                    />
                ) : (
                    <div />
                )}
                <div className="auto-link-users-container">{autoLinkUsersButton}</div>
                <div className="search-user-container">
                    <div className="title-manual-link-user">
                        <Literal literal="label_manual_user_link_salesforce" />
                    </div>
                    <div className="link-users-search">
                        <div className="label-users">
                            <Literal literal="label_FMUsers_salesforce" />:
                        </div>
                        {searchForcemanagerUsers}
                    </div>
                    <div className="link-users-search">
                        <div className="label-users">
                            <Literal literal="label_SFUsers_salesforce" />:{' '}
                        </div>
                        {searchSalesforceUsers}
                    </div>
                </div>
                <div className="add-linked-user-container">{addLinkedUserButton}</div>
                <div className="linked-users-count">
                    {linkedUsers ? linkedUsers.length : 0}
                    <span> </span>
                    <Literal literal="label_linked_users_salesforce" />
                </div>
                <div className="linked-users-container">
                    <div className="linked-users-header">
                        <div className="linked-users-header-title">
                            <Literal literal="label_FMUsers_salesforce" />
                        </div>
                        <div className="linked-users-header-title">
                            <Literal literal="label_SFUsers_salesforce" />
                        </div>
                    </div>
                    <Scrollbars style={stylejs.scrollContent}>{linkedUsersContent}</Scrollbars>
                </div>
                <div className="configuration-buttons">
                    {saveButton}
                    {cancelButton}
                </div>
            </div>
        );
    };

    linkedUsers = (data) => {
        let linkedUsers = [];
        for (let i = 0; i < data.usersdata[0].users.length; i++) {
            if (data.usersdata[0].users[i].ExtId !== '') {
                for (let j = 0; j < data.usersdata[1].users.length; j++) {
                    if (data.usersdata[0].users[i].ExtId === data.usersdata[1].users[j].Id) {
                        let linkedUser = {};
                        linkedUser.FMUser = data.usersdata[0].users[i].Name;
                        linkedUser.FMId = data.usersdata[0].users[i].Id;
                        linkedUser.SalesforceUser = data.usersdata[1].users[j].Name;
                        linkedUser.SalesforceId = data.usersdata[1].users[j].Id;
                        linkedUsers.push(linkedUser);
                        data.usersdata[0].users.splice(i, 1);
                        data.usersdata[1].users.splice(j, 1);
                        break;
                    }
                }
                break;
            }
        }
        return linkedUsers;
    };

    renderLinkedUsers = () => {
        let { linkedUsers } = this.state;
        if (linkedUsers && linkedUsers.length > 0) {
            let linkedUsersContent = linkedUsers.map((linkedUsers) => {
                return (
                    <div className="linked-user-container">
                        <div className="linked-user">{linkedUsers.FMUser || ''}</div>
                        <div className="linked-user">{linkedUsers.SalesforceUser || ''}</div>
                        <div
                            className="delete-linked-user"
                            onClick={() => this.deleteLinkedUser(linkedUsers.FMId)}
                        >
                            X
                        </div>
                    </div>
                );
            });
            return linkedUsersContent;
        } else {
            return (
                <div className="no-linked-users">
                    <div className="ic-warning-filled" />
                    <div className="no-linked-users-desc">
                        <Literal literal="label_no_linked_users_salesforce" />
                    </div>
                </div>
            );
        }
    };

    addLinkedUser = () => {
        let { FMUserToLink, FMUserIdToLink, SFUserIdToLink, SFUserToLink, linkedUsers, usersData } =
            this.state;
        let linkedUser = {};
        let addLinkedUser = true;
        if (FMUserIdToLink && SFUserIdToLink) {
            for (let i = 0; i < linkedUsers.length; i++) {
                if (
                    linkedUsers[i].FMId === FMUserIdToLink ||
                    linkedUsers[i].SalesforceId === SFUserIdToLink
                ) {
                    addLinkedUser = false;
                }
            }
        } else {
            addLinkedUser = false;
        }

        if (addLinkedUser) {
            linkedUser.FMUser = FMUserToLink;
            linkedUser.FMId = FMUserIdToLink;
            linkedUser.SalesforceUser = SFUserToLink;
            linkedUser.SalesforceId = SFUserIdToLink;
            linkedUsers.push(linkedUser);

            for (let i = 0; i < usersData.usersdata[0].users.length; i++) {
                if (usersData.usersdata[0].users[i].Id === FMUserIdToLink) {
                    usersData.usersdata[0].users.splice(i, 1);
                    break;
                }
            }

            for (let j = 0; j < usersData.usersdata[1].users.length; j++) {
                if (usersData.usersdata[1].users[j].Id === SFUserIdToLink) {
                    usersData.usersdata[1].users.splice(j, 1);
                    break;
                }
            }
        }
        this.setState({
            usersData: usersData,
            linkedUsers: linkedUsers,
            FMUserIdToLink: null,
            SFUserIdToLink: null,
            FMUserToLink: '',
            SFUserToLink: '',
        });
    };

    deleteLinkedUser = (deletedLinkedUser) => {
        let { linkedUsers, usersData } = this.state;
        for (let i = 0; i < linkedUsers.length; i++) {
            if (linkedUsers[i].FMId === deletedLinkedUser) {
                let FMUser = {};
                let SalesforceUser = {};

                FMUser.ExtId = '';
                FMUser.Id = linkedUsers[i].FMId;
                FMUser.Name = linkedUsers[i].FMUser;
                usersData.usersdata[0].users.push(FMUser);

                SalesforceUser.Id = linkedUsers[i].SalesforceId;
                SalesforceUser.Name = linkedUsers[i].SalesforceUser;
                usersData.usersdata[1].users.push(SalesforceUser);

                linkedUsers.splice(i, 1);

                break;
            }
        }

        this.setState({ usersData: usersData, linkedUsers: linkedUsers });
    };

    onClickAutoLinkUsers = () => {
        let { linkedUsers, usersData } = this.state;
        for (let i = 0; i < usersData.usersdata[0].users.length; i++) {
            for (let j = 0; j < usersData.usersdata[1].users.length; j++) {
                if (usersData.usersdata[0].users[i].Name === usersData.usersdata[1].users[j].Name) {
                    let linkedUser = {};
                    linkedUser.FMUser = usersData.usersdata[0].users[i].Name;
                    linkedUser.FMId = usersData.usersdata[0].users[i].Id;
                    linkedUser.SalesforceUser = usersData.usersdata[1].users[j].Name;
                    linkedUser.SalesforceId = usersData.usersdata[1].users[j].Id;
                    linkedUsers.push(linkedUser);
                    usersData.usersdata[0].users.splice(i, 1);
                    usersData.usersdata[1].users.splice(j, 1);
                    break;
                }
            }
        }
        this.setState({ linkedUsers: linkedUsers });
    };

    renderStatusTab = () => {
        let { cronstatus, syncEntities, logData } = this.state;
        let apiCalls = logData ? (
            <div className="current-api-calls-salesforce">
                <Literal literal="label_api_calls_24h_salesforce" />
                <span className="api-call-number-salesforce">
                    {' '}
                    {parseInt(logData.requestCount)}
                </span>
            </div>
        ) : (
            <div />
        );
        let disableButton = (
            <div>
                <Button
                    className="btn-primary"
                    style={stylejs.btnCustomDisable}
                    text={<Literal literal="action_disable_integration" />}
                    onClick={this.onClickDisable}
                />
            </div>
        );
        let configurationButton = (
            <div>
                <Button
                    className="btn-primary-configuration"
                    style={stylejs.btnCustom}
                    text={<Literal literal="action_config_integration" />}
                    onClick={this.onClickGoToConfig}
                />
            </div>
        );

        let currentConfiguration = (
            <div className="current-config-container">
                <Literal
                    className="salesforce-current-configuration-subtitle"
                    literal="title_current_configuration_salesforce"
                />
                <table className="salesforce-current-config-table">
                    <thead>
                        <tr>
                            <th className="header-current-config-entity">
                                <Literal literal="label_entities_salesforce" />
                            </th>
                            <th>
                                <Literal literal="label_active" />
                            </th>
                            <th>
                                <Literal literal="label_bidireccional_salesforce" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="row-current-config-salesforce">
                            <td className="row-current-config-entity">
                                <Literal literal="title_accounts" />
                            </td>
                            {syncEntities.accounts === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                            {syncEntities.accounts_bi === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                        </tr>
                        <tr className="row-current-config-salesforce">
                            <td className="row-current-config-entity">
                                <Literal literal="title_contacts" />
                            </td>
                            {syncEntities.contacts === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                            {syncEntities.contacts_bi === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                        </tr>
                        <tr className="row-current-config-salesforce">
                            <td className="row-current-config-entity">
                                <Literal literal="title_opportunities" />
                            </td>
                            {syncEntities.opportunities === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                            {syncEntities.opportunities_bi === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                        </tr>
                        <tr className="row-current-config-salesforce">
                            <td className="row-current-config-entity">
                                <Literal literal="title_activities" />
                            </td>
                            {syncEntities.activities === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                            {syncEntities.activities_bi === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                        </tr>
                        <tr className="row-current-config-salesforce">
                            <td className="row-current-config-entity">
                                <Literal literal="title_events" />
                            </td>
                            {syncEntities.events === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                            {syncEntities.events_bi === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                        </tr>
                        <tr className="row-current-config-salesforce">
                            <td className="row-current-config-entity">
                                <Literal literal="title_tasks" />
                            </td>
                            {syncEntities.tasks === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                            {syncEntities.tasks_bi === 1 ? (
                                <td>
                                    <div className="current-config-checked-salesforce ic-thick" />
                                </td>
                            ) : (
                                <td />
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        );

        if (cronstatus === 'enabled') {
            return (
                <div className="salesforce-inside-tab-content">
                    <div>
                        <span className="oval oval-green" />
                        <Literal
                            className="salesforce-status-text"
                            literal="label_enabled_sync_integration"
                        />
                    </div>
                    <div className="salesforce-status-desc">
                        <Literal literal="label_enabled_sync_description_salesforce" />
                    </div>
                    {apiCalls}
                    {currentConfiguration}
                    <div className="status-tab-buttons-container">
                        {configurationButton}
                        {disableButton}
                    </div>
                </div>
            );
        } else if (cronstatus === 'inprogress') {
            return (
                <div className="salesforce-inside-tab-content">
                    <div>
                        <span className="oval oval-yellow" />
                        <Literal
                            className="salesforce-status-text"
                            literal="label_initial_sync_integration"
                        />
                        <div className="spinner-salesforce">
                            <div className="bounce1-salesforce" />
                            <div className="bounce2-salesforce" />
                            <div className="bounce3-salesforce" />
                        </div>
                    </div>
                    <div className="salesforce-status-desc">
                        <Literal literal="label_sync_description_salesforce" />
                    </div>
                    {currentConfiguration}
                    {apiCalls}
                    <div className="status-tab-buttons-container">
                        {configurationButton}
                        {disableButton}
                    </div>
                </div>
            );
        } else if (cronstatus === 'no cron') {
            return (
                <div className="salesforce-inside-tab-content">
                    <div>
                        <span className="oval oval-yellow" />
                        <Literal
                            className="salesforce-status-text"
                            literal="label_cofiguration_missed_salesforce"
                        />
                    </div>
                    <div className="salesforce-status-desc">
                        <Literal literal="label_cofiguration_missed_desc_salesforce" />
                    </div>
                    <div className="status-tab-buttons-container">
                        {configurationButton}
                        {disableButton}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="salesforce-inside-tab-content">
                    <div>
                        <span className="oval oval-red" />
                        <Literal
                            className="salesforce-status-text"
                            literal="label_failed_sync_integration"
                        />
                    </div>
                    <div className="salesforce-status-desc">
                        <Literal literal="label_failed_sync_description_integration" />
                    </div>
                    {apiCalls}
                    {currentConfiguration}
                    <div className="status-tab-buttons-container">
                        {configurationButton}
                        {disableButton}
                    </div>
                </div>
            );
        }
    };

    renderSalesforceStatisticts = () => {
        let { matchingData, cronstatus, logData } = this.state;
        let { locale } = this.props;
        if (matchingData) {
            let statistics = matchingData.data.entities.map((item) => {
                let gender = this.getEntityGenderFromLocale(locale, item.entity);
                return (
                    <SalesforceStatisticGrid
                        data={item}
                        key={item.entity}
                        literal={matchingData.metaData[item.entity]}
                        gender={gender}
                    />
                );
            });
            let logTable = this.renderLogsTable(logData);
            return (
                <div className="salesforce-inside-tab-content">
                    <div className="salesforce-stats-desc">
                        <Literal literal="label_stats_description_salesforce" />
                    </div>
                    <div className="salesforce-grid">{statistics}</div>
                    <div className="salesforce-log-table-container">
                        <div className="salesforce-log-table-desc">
                            <Literal literal="label_logs_description_salesforce" />
                        </div>
                        {this.renderLogsTable(logData)}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="salesforce-inside-tab-content">
                    <Literal
                        className="salesforce-no-stats-content"
                        literal="label_no_stats_content_salesforce"
                    />
                </div>
            );
        }
    };

    getEntityGenderFromLocale = (locale, entities) => {
        let gender = '';
        let entity = entities.toLowerCase();
        switch (locale.toLowerCase()) {
            case 'es-es':
                if (entity === 'contact' || entity === 'event') gender = 'm';
                else gender = 'f';
                break;
            case 'fr-fr':
                if (entity === 'contact' || entity === 'event' || entity === 'account')
                    gender = 'm';
                else gender = 'f';
                break;
            case 'it-it':
                if (entity === 'contact' || entity === 'event' || entity === 'task') gender = 'm';
                else gender = 'f';
                break;
            case 'pt-pt':
                if (entity === 'contact' || entity === 'event') gender = 'm';
                else gender = 'f';
                break;
            default:
                gender = 'm';
                break;
        }
        return gender;
    };

    renderLogsTable = (logData) => {
        return (
            <table className="salesforce-logs-table">
                <thead>
                    <tr>
                        <th className="w-100" />
                        <th className="w-200" />
                        <th className="w-200">
                            <Literal literal="common_date" />
                        </th>
                        <th>
                            <Literal literal="label_sync_result_salesforce" />
                        </th>
                    </tr>
                </thead>
                <tbody>{this.renderLogRows(logData)}</tbody>
            </table>
        );
    };

    renderLogRows = (logData) => {
        let { locale } = this.props;
        let logRows = logData.logs.map((log) => {
            let createdDateFormatted = '';
            let action = '';
            if (log.fcreado) {
                createdDateFormatted = Context.utilsFormats.formatStringByInputFormat(
                    log.fcreado,
                    'YYYY-MM-DDTHH:mm:ss',
                    true,
                );
            }
            if (log.action) {
                switch (log.action) {
                    case 'PUT':
                    case 'PATCH':
                        action =
                            log.result === 'succeed' ? (
                                <span>
                                    <Literal
                                        literal={'label_update_' + log.entity + '_salesforce'}
                                    />
                                </span>
                            ) : (
                                <span>
                                    <Literal
                                        literal={
                                            'label_failed_update_' + log.entity + '_salesforce'
                                        }
                                    />{' '}
                                    <Literal literal="label_entity_sync_error_salesforce" />
                                </span>
                            );
                        break;
                    case 'POST':
                        action =
                            log.result === 'succeed' ? (
                                <span>
                                    <Literal
                                        literal={'label_insert_' + log.entity + '_salesforce'}
                                    />
                                </span>
                            ) : (
                                <span>
                                    <Literal
                                        literal={
                                            'label_failed_insert_' + log.entity + '_salesforce'
                                        }
                                    />{' '}
                                    <Literal literal="label_entity_sync_error_salesforce" />
                                </span>
                            );
                        break;
                    case 'DELETE':
                        action =
                            log.result === 'succeed' ? (
                                <span>
                                    <Literal
                                        literal={'label_delete_' + log.entity + '_salesforce'}
                                    />
                                </span>
                            ) : (
                                <span>
                                    <Literal
                                        literal={
                                            'label_failed_delete_' + log.entity + '_salesforce'
                                        }
                                    />{' '}
                                    <Literal literal="label_entity_sync_error_salesforce" />
                                </span>
                            );
                        break;
                }
            }
            let origin = (
                <div className="app-logo-container">
                    {log.originApp === 'salesforce' ? (
                        <img className="app-logo" src={PATH_IMAGE + 'salesforce_logo.png'} />
                    ) : (
                        <img className="app-logo" src={PATH_IMAGE + 'forcemanager_logo.png'} />
                    )}
                    <div className="sync-direction-salesforce" />
                    {log.originApp === 'salesforce' ? (
                        <img className="app-logo" src={PATH_IMAGE + 'forcemanager_logo.png'} />
                    ) : (
                        <img className="app-logo" src={PATH_IMAGE + 'salesforce_logo.png'} />
                    )}
                </div>
            );
            let result =
                log.result === 'succeed' ? (
                    <div className="log-succed-salesforce ic-thick" />
                ) : (
                    <div className="log-failed-salesforce ic-close" />
                );
            let redirectUrl = SalesforceUtils.getEntityUrl(log.idEntity, log.entity);
            ///*{log.result === 'succeed' ?<td className="go-to-entity" onClick={() =>window.location.href = {redirectUrl}}>{action}: {log.descEntity}</td> : <td className="go-to-entity">{action}: {log.message}</td>}*/
            return (
                <tr>
                    <td className="w-100">{result}</td>
                    <td className="w-200">{origin}</td>
                    <td className="w-200">{createdDateFormatted}</td>
                    {log.result === 'succeed' ? (
                        <td>
                            {action}: {log.descEntity}
                        </td>
                    ) : (
                        <td className="go-to-entity">
                            {action}: {log.message}
                        </td>
                    )}
                </tr>
            );
        });

        return logRows;
    };

    onClickDisable = () => {
        this.setState({
            showDisableDialog: true,
            showConfirmationDialog: true,
            showInputDialog: false,
        });
    };

    handleDisable = () => {
        this.setState({ showLoadingConfirmationDialog: true });
        let { providerId } = this.state;
        Context.settingsManager.disableIntegration(
            providerId,
            () => {
                this.setState({
                    showConfirmationDialog: false,
                    showDisableDialog: false,
                    showLoadingConfirmationDialog: false,
                    showInputDialog: true,
                    validAuth: false,
                    isActive: false,
                    forceGoToAuthorize: false,
                });
            },
            (error) => {
                console.log('error isactive');
            },
        );
    };

    renderSalesforceTabsContent = () => {
        let { loadingSalesforceTabs, errorSalesforceTabs } = this.state;
        let renderContent = loadingSalesforceTabs ? (
            this.renderLoading()
        ) : errorSalesforceTabs ? (
            this.renderError()
        ) : (
            <TabContent>
                <Tab
                    literal="label_status_integration"
                    className="first-tab"
                    content={this.renderStatusTab()}
                />
                <Tab
                    literal="label_statistics_salesforce"
                    content={this.renderSalesforceStatisticts()}
                />
            </TabContent>
        );
        return renderContent;
    };

    render() {
        let { provider } = this.props;
        let {
            error,
            loading,
            isActive,
            validAuth,
            showConfirmationDialog,
            showLoadingConfirmationDialog,
            salesforceOAuthProcess,
            showAuthDialog,
            showInputDialog,
            showDisableDialog,
            showUserConfiguration,
            logData,
        } = this.state;
        let renderContent = loading
            ? this.renderLoading()
            : error
              ? this.renderError()
              : salesforceOAuthProcess
                ? this.renderOauthInProcess()
                : !isActive || !validAuth
                  ? this.renderSalesforceActivation(provider)
                  : !validAuth
                    ? this.renderOauthInProcess()
                    : showUserConfiguration
                      ? this.renderUserConfiguration()
                      : this.renderSalesforceTabsContent();
        let onClickAccept = !showDisableDialog
            ? !showAuthDialog
                ? this.handleActivation
                : this.onClickAuthorize
            : this.handleDisable;
        let literalTitle = !showDisableDialog
            ? !showAuthDialog
                ? 'title_activate_integration_salesforce'
                : 'title_auth_integration_salesforce'
            : 'action_disable_integration';
        let literalDesc1 = !showDisableDialog
            ? !showAuthDialog
                ? 'label_activation_desc_1_salesforce'
                : 'label_auth_desc_salesforce'
            : 'label_disable_salesforce';
        let literalDesc2 = !showDisableDialog
            ? !showAuthDialog
                ? 'label_activation_desc_2_salesforce'
                : ''
            : '';
        let literalDesc3 = !showDisableDialog
            ? !showAuthDialog
                ? 'label_activation_desc_3_salesforce'
                : ''
            : '';
        let literalActionAccept = !showDisableDialog
            ? !showAuthDialog
                ? 'action_continue'
                : 'action_authorize'
            : 'action_accept';
        return (
            <div>
                {renderContent}
                <ConfirmationDialog
                    showDialog={showConfirmationDialog}
                    showLoadingDialog={showLoadingConfirmationDialog}
                    onClickCancel={this.handleActivationClose}
                    onClickAccept={onClickAccept}
                    handleClose={this.handleActivationClose}
                    literalTitle={literalTitle}
                    literalDesc1={literalDesc1}
                    literalDesc2={literalDesc2}
                    literalDesc3={literalDesc3}
                    literalActionCancel={'action_cancel'}
                    literalActionAccept={literalActionAccept}
                    error={error}
                    providerId={provider.data.ProviderId}
                    showInputDialog={showInputDialog}
                />
            </div>
        );
    }
}
